import { CollectionName } from "@snubes/snubes-types";
import { collection } from "firebase/firestore";
import { db } from "../consts/FIREBASE";

export function getCollectionRef(collectionName: CollectionName) {
  return collection(db, collectionName);
}
